import useApiQuery from 'shared/hooks/use-api-query';
import {ProfileProps} from '../types';
import useToken from 'modules/auth/atoms/use-token';
import {useEffect} from 'react';
import useUserProjection from '../atoms/use-user-projection';
import useProfileStorage from '../atoms/use-profile-storage';

const useProfile = () => {
  const {token} = useToken();
  const {setUserProjection} = useUserProjection();
  const {profile, setProfile} = useProfileStorage();

  const {data, ...query} = useApiQuery<ProfileProps>({
    url: '/users/me',
    enabled: !!token,
    staleTime: 10 * 60 * 1000, //10 min
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
  });

  useEffect(() => {
    if (data) {
      setUserProjection(data?.savedFields);
      setProfile(data);
    }
  }, [data]);

  return {data: data ?? profile, ...query};
};

export default useProfile;
